// extracted by mini-css-extract-plugin
export default {"container":"DefaultSpinner_container__GjIyY","containerVisible":"DefaultSpinner_containerVisible__DjG2q"};